import type { BoundElementDefinition } from '../types';
import { createDefaultTableLayoutFromBinding } from './runtimeBinding';
import {
    createDefaultStaticTableSettings,
    type TableBinding,
    type TableSettings,
} from './contracts';
import { getBindingCatalog, createBindingId } from '../../runtime/dataServices/bindingCatalog';
import { createRuntimeBindingInsertionPresetsForKind } from '../runtimeBindingPresetUtils';
import { createBoundElementDefinition } from '../types';

export type TableDefinition = BoundElementDefinition<'table', TableSettings>;

export function createBlankTableDefinition(): TableDefinition {
    return createBoundElementDefinition('table', {
        ...createDefaultStaticTableSettings(),
        binding: null,
    });
}

function createTableDefinitionForBinding(binding: TableBinding): TableDefinition {
    return createBoundElementDefinition('table', {
        ...createDefaultTableLayoutFromBinding(binding),
        binding: { bindingId: createBindingId(binding) },
    });
}

export function createRuntimeTableInsertionPresets() {
    return createRuntimeBindingInsertionPresetsForKind({
        valueKind: 'tabular',
        keyPrefix: 'table_binding',
        createDefinitionForBindingId: (_bindingId, descriptor) =>
            createTableDefinitionForBinding(getBindingCatalog().toActiveDataBinding(descriptor)),
    });
}
